import { render, staticRenderFns } from "./ClientPut.vue?vue&type=template&id=6ba2a5a8"
import script from "./ClientPut.vue?vue&type=script&lang=js"
export * from "./ClientPut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports